import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider } from '@tanstack/react-query';
import { getCategoryFilter, getCategoryTree, useCategoryStore } from '../../store/category';
import { getTemplateData } from '../../utils';
import Loader from '../loader';
import { useGlobalSettings } from '../global-settings';
import { queryClient } from '../../api';
import Category from './filter/category';
import CategoryHomepage from './filter/caregory-homepage';
function CategoryTemplate({ templateData, children }) {
    const categoryId = getTemplateData('data-category-id', templateData);
    const setCategory = useCategoryStore((state) => state.set);
    const { isInited } = useGlobalSettings(async (config) => {
        const promises = await Promise.all([getCategoryFilter(config.api.category.get, categoryId), getCategoryTree(config.api.category.tree_list)]);
        setCategory(promises[0], promises[1]);
    });
    if (!isInited)
        return _jsx(Loader, {});
    return _jsx(QueryClientProvider, { client: queryClient, children: children });
}
export function CategoryTemplateCategory(props) {
    return (_jsx(CategoryTemplate, { ...props, children: _jsx(Category, {}) }));
}
export function CategoryTemplateHomepage(props) {
    return (_jsx(CategoryTemplate, { ...props, children: _jsx(CategoryHomepage, {}) }));
}
